module.exports = {
  ACT_NUMBER: 'act_number',
  WORKER_NUMBER: 'worker_number',
};
